<div class="ec-energy-data-container">
    <form [formGroup]="form" fxLayout="column">
        <div fxLayout="column" fxLayoutGap="20px">
            <div fxLayout="row" fxLayoutAlign="center center" class="txt">
                {{'Enter the data counted by the GSE for the month of'|i18n}}
                &nbsp;<b>{{month}} {{year}}</b>.
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="40" class="txt-p-16-4">{{('Absorbed energy'|i18n) + ':*'}}</div>
                <div app-input-container fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxFlex>
                    <input app-input
                           type="number"
                           step="0.01"
                           formControlName="absorbedEnergy"
                           (input)="limitDecimals(form, 'absorbedEnergy')"
                           class="t-right">
                    <span class="txt-p-16-4" fxFlex="10">kWh</span>
                </div>
                <div fxFlex="30"></div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="40" class="txt-p-16-4">{{('Effective injected energy'|i18n) + ':*'}}</div>
                <div app-input-container fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxFlex>
                    <input app-input
                           type="number"
                           step="0.01"
                           formControlName="effectiveInjectedEnergy"
                           (input)="limitDecimals(form, 'effectiveInjectedEnergy')"
                           class="t-right">
                    <span class="txt-p-16-4" fxFlex="10">kWh</span>
                </div>
                <div fxFlex="30"></div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="40" class="txt-p-16-4">{{('Shared energy'|i18n) + ':*'}}</div>
                <div app-input-container fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxFlex>
                    <input app-input
                           type="number"
                           step="0.01"
                           formControlName="sharedEnergy"
                           (input)="limitDecimals(form, 'sharedEnergy')"
                           class="t-right">
                    <span class="txt-p-16-4" fxFlex="10">kWh</span>
                </div>
                <div fxFlex="30"></div>
            </div>
        </div>
    </form>
</div>
